<template>
  <div class="invite-header">
    <img
      class="invite-header__back"
      src="@/assets/home/icn_arrow_left.png"
      @click="$emit('back-click')"
    />
    <span class="invite-header__title typo-heading-xl-bold">초대하기</span>
  </div>
</template>

<script>
export default {
  name: 'InviteHeader',
}
</script>

<style scoped>
.invite-header {
  display: flex;
  width: 100%;
  height: 64px;
  padding: 16px 16px 17px 16px;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  background: #FFF;
  gap: 16px;
}

.invite-header__back {
  width: 24px;
  height: 24px;
  cursor: pointer;
  flex-shrink: 0;
}

.invite-header__title {
  color: var(--color-text-main, #191F28);
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/InviteHeader.vue